import { createSlice } from '@reduxjs/toolkit';
import { handleChangePassword } from '~/thunks/auth/changePasswordThunk';
import { handleLogin } from '~/thunks/auth/authThunk';
import { StorageEnum } from '~/utils/enum';

export interface AuthState {
  accessToken: string | null | undefined;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  accessToken: localStorage.getItem(StorageEnum.ACCESS_TOKEN)! || null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleLogout() {
      localStorage.removeItem(StorageEnum.ACCESS_TOKEN);
    },
  },
  extraReducers(builder) {
    builder.addCase(handleLogin.fulfilled, (_state, action) => {
      localStorage.setItem(StorageEnum.ACCESS_TOKEN, action.payload.token.access);
      localStorage.setItem(StorageEnum.REFRESH_TOKEN, action.payload.token.refresh);
      localStorage.setItem(StorageEnum.USER_ID, action.payload.account.id);
    });

    builder
      .addCase(handleChangePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(handleChangePassword.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(handleChangePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as { message?: string } | undefined)?.message || 'Failed to change password';
      });
  },
});

export const authActions = authSlice.actions;

const authReducer = authSlice.reducer;
export default authReducer;
